import React, { useState, useEffect } from "react";

import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';

export default function Introduction({resume}) {
    const [time, setTime] = useState("");
    
    useEffect(() => {
        const updateTime = () => {
            const mstTime = new Date().toLocaleString("en-US", {
                timeZone: "America/Phoenix",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
            });
            setTime(mstTime);
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);

        return () => clearInterval(interval);
    }, []);

    const interests = [
        {
            label: 'Software Development',
            image: 'code-icon.png'

        },
        {
            label: 'Data Engineering',
            image: 'data-icon.png'
        },
        {
            label: 'Machine Learning',
            image: 'robot-icon.png'
        },
        {
            label: 'Deep Learning',
            image: 'neural-icon.png'
        },
        {
            label: 'Cloud & Storage Platforms',
            image: 'cloud-icon.png'
        },
        {
            label: 'Distributed Systems',
            image: 'deployment-icon.png'
        }
    ];

    const locationLabel = "Tempe, Arizona, United States";

    return (
        <div id="introduction" className='grid'>
            <div className='col-12 lg:col-3 flex justify-content-center align-items-center'>
                <Avatar image={require(`../../static/assets/display-picture.jpeg`)} className="mx-auto" style={{"width": "10rem", "height": "10rem"}} shape="circle" />
            </div>
            <div className='col-12 lg:col-9'>
                <h1>Hey, I'm Prathamesh ✌️</h1>
                <p className="gray">A lifelong problem-solver with a knack for exploring the 'why' behind everything. Curiosity is what got me here — turning data into knowledge, optimizing systems, and building intelligent solutions. With a background in Data Science, Engineering, and Machine Learning, I love creating seamless, data-driven experiences that solve real-world problems. Every dataset tells a story — I just help uncover it.</p>
            </div>
            <div className='col-12'>
                <h3 className='mt-0'>Where curosity leads me?</h3>
                <div className='interests card flex flex-wrap gap-2'>
                    {interests.map((interest) => (
                        <Chip key={interest.label} label={interest.label} image={require(`../../static/assets/icons/${interest.image}`)} />
                    )) }
                </div>
            </div>
            <div className='col-12 lg:col-6'>
                <h3>Got an idea? Shoot me an email!</h3>
                <Button label="Reach Out" icon="pi pi-envelope" size='small' rounded 
                    onClick={() => window.location.href = 'mailto:prathameshlakawade@gmail.com'} />
            </div>
            <div className='col-12 lg:col-6'>
                <h3>Want to team up? Grab my resume!</h3>
                <Button label="Resume" icon="pi pi-file-pdf" size='small' rounded 
                    onClick={() => window.open(resume, '_blank')} />
            </div>
            <div className="col-12">
                <h2 className="mt-5">Based In</h2>
                <div className="location-image-container">
                    <img src={require(`../../static/assets/current-location.png`)} alt="Current Location" />
                    <div className="overlay-chip-stack">
                        <div className="overlay-chip-stack-top">
                            <div className="overlay-chip console"><i className="pi pi-clock" /> {time} MST</div>
                        </div>
                        <div className="overlay-chip-stack-bottom">
                            <div className="overlay-chip console"><i className="pi pi-map-marker" /> {locationLabel}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
